/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetProjectsProjectidSelectionsOptions, GetProjectsProjectidSelectionsStatus200, GetProjectsProjectidSelectionsStatus401 } from '../types/GetProjectsProjectidSelections'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getProjectsProjectidSelections } from '../clients/getProjectsProjectidSelections'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getProjectsProjectidSelectionsQueryKey = ({ path, query }: Omit<GetProjectsProjectidSelectionsOptions, 'headers'>) => [{ url: '/projects/:projectId/selections/', params: path }, ...(query ? [query] : [])] as const

type GetProjectsProjectidSelectionsQueryKey = ReturnType<typeof getProjectsProjectidSelectionsQueryKey>

export function getProjectsProjectidSelectionsQueryOptions({ path, query }: GetProjectsProjectidSelectionsOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getProjectsProjectidSelectionsQueryKey({ path, query })
  return queryOptions<GetProjectsProjectidSelectionsStatus200, ResponseErrorConfig<GetProjectsProjectidSelectionsStatus401>, GetProjectsProjectidSelectionsStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getProjectsProjectidSelections({ ...config, path, query, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /projects/:projectId/selections/}
 */
export function useGetProjectsProjectidSelections<TData = GetProjectsProjectidSelectionsStatus200, TQueryData = GetProjectsProjectidSelectionsStatus200, TQueryKey extends QueryKey = GetProjectsProjectidSelectionsQueryKey>({ path, query }: { path: GetProjectsProjectidSelectionsOptions['path'] | (() => GetProjectsProjectidSelectionsOptions['path']); query?: GetProjectsProjectidSelectionsOptions['query'] | (() => GetProjectsProjectidSelectionsOptions['query']) }, options: {
  query?: Partial<QueryObserverOptions<GetProjectsProjectidSelectionsStatus200, ResponseErrorConfig<GetProjectsProjectidSelectionsStatus401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path, query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getProjectsProjectidSelectionsQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getProjectsProjectidSelectionsQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetProjectsProjectidSelectionsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
